import { API } from 'aws-amplify'

export default function declareBidDocument(data) {
  const mutation = `mutation declareBidDocument (
                $tender_id: String!
                $format: String!
                $title: String!
                $documentType: String
                ${data.relatedItem ? '$relatedItem: String' : ''}
                ${data.relatedMpItem ? '$relatedMpItem: String' : ''}
                $language: String
            ) {
            declareBidDocument(
                tender_id: $tender_id
                format: $format
                title: $title
                documentType: $documentType
                ${data.relatedItem ? 'relatedItem: $relatedItem' : ''}
                ${data.relatedMpItem ? 'relatedMpItem: $relatedMpItem' : ''}
                language: $language
            ) {
                mpID
                owner_token
            }
        }`

  const variables = {
    tender_id: data.tenderId,
    format: data.format,
    title: data.title,
    documentType: data.documentType || null,
    relatedItem: data.relatedItem,
    language: data.language,
  }
  if (data.relatedMpItem) {
    variables.relatedMpItem = data.relatedMpItem;
  }
  return API.graphql({
    query: mutation,
    variables,
  })
}
